import React, { createContext, useContext } from 'react';
import styles from './ListTable.scss';
var ListTableVariantContext = createContext('default');
export var useListTableVariantContext = function useListTableVariantContext() {
  return useContext(ListTableVariantContext);
};
export var ListTable = function ListTable(_ref) {
  var variant = _ref.variant,
      dataTest = _ref.dataTest,
      children = _ref.children;
  return React.createElement(ListTableVariantContext.Provider, {
    value: variant
  }, React.createElement("div", {
    className: styles.container,
    "data-test": dataTest
  }, children));
};